import ConditionProperty from './ConditionProperty';
import ConditionVisibleControls from "./ConditionVisibleControls";

export default class UnstructuredEventNameProperty extends ConditionProperty {
  static override readonly label: string = 'Unstructured event name property';
  static override readonly formFields: ConditionVisibleControls  = { fieldName: false, fieldPath: false, fieldIndex: false };
  static override readonly type: number = 5;

  buildDescription(): string {
    return `Event name ${this.getOperatorLabel()} [${this.condition.value}]`;
  }
}
